import { FC } from "react";
import { TICKET_STATUS_LABELS } from "../model/constants";
import type { SupportTicketStatus } from "../model/types";

import styles from "./TicketStatusBadge.module.css";

interface Props {
  status: SupportTicketStatus;
}

export const TicketStatusBadge: FC<Props> = ({ status }) => (
  <span className={`${styles.badge} ${styles[status]}`}>
    {TICKET_STATUS_LABELS[status]}
  </span>
);
